/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { StreemApiCreateAppRequestToJSON, StreemApiCreateAppResponseFromJSON, StreemApiGetAppResponseFromJSON, StreemApiImportGlobalAppRequestToJSON, StreemApiImportGlobalAppResponseFromJSON, StreemApiListAppsResponseFromJSON, StreemApiUpdateAppIosVoipCredentialsRequestToJSON, } from '../models';
/**
 *
 */
export class AppsApi extends runtime.BaseAPI {
    /**
     * Create an App
     */
    async createAppRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/apps`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateAppRequestToJSON(requestParameters.streemApiCreateAppRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateAppResponseFromJSON(jsonValue));
    }
    /**
     * Create an App
     */
    async createApp(streemApiCreateAppRequest) {
        const response = await this.createAppRaw({ streemApiCreateAppRequest: streemApiCreateAppRequest });
        return await response.value();
    }
    /**
     * Get an App with the given `app_sid`
     * Get App
     */
    async getAppRaw(requestParameters) {
        if (requestParameters.appSid === null || requestParameters.appSid === undefined) {
            throw new runtime.RequiredError('appSid', 'Required parameter requestParameters.appSid was null or undefined when calling getApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/apps/{app_sid}`.replace(`{${"app_sid"}}`, encodeURIComponent(String(requestParameters.appSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetAppResponseFromJSON(jsonValue));
    }
    /**
     * Get an App with the given `app_sid`
     * Get App
     */
    async getApp(appSid) {
        const response = await this.getAppRaw({ appSid: appSid });
        return await response.value();
    }
    /**
     * Import an App from the Global Region, which must be multiCompanyLoginAllowed = true
     * Import Global App
     */
    async importGlobalAppRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/apps/~import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiImportGlobalAppRequestToJSON(requestParameters.streemApiImportGlobalAppRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiImportGlobalAppResponseFromJSON(jsonValue));
    }
    /**
     * Import an App from the Global Region, which must be multiCompanyLoginAllowed = true
     * Import Global App
     */
    async importGlobalApp(streemApiImportGlobalAppRequest) {
        const response = await this.importGlobalAppRaw({ streemApiImportGlobalAppRequest: streemApiImportGlobalAppRequest });
        return await response.value();
    }
    /**
     * List all apps for your company.
     * List Apps
     */
    async listAppsRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        if (requestParameters.companySid !== undefined) {
            queryParameters['company_sid'] = requestParameters.companySid;
        }
        if (requestParameters.multiCompanyLoginAllowed !== undefined) {
            queryParameters['multi_company_login_allowed'] = requestParameters.multiCompanyLoginAllowed;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/apps`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListAppsResponseFromJSON(jsonValue));
    }
    /**
     * List all apps for your company.
     * List Apps
     */
    async listApps(pageSize, pageToken, companySid, multiCompanyLoginAllowed) {
        const response = await this.listAppsRaw({ pageSize: pageSize, pageToken: pageToken, companySid: companySid, multiCompanyLoginAllowed: multiCompanyLoginAllowed });
        return await response.value();
    }
    /**
     * Update IOS VOIP credentials for the given app
     * Update IOS VOIP Creds
     */
    async updateAppIosVoipCredentialsRaw(requestParameters) {
        if (requestParameters.appSid === null || requestParameters.appSid === undefined) {
            throw new runtime.RequiredError('appSid', 'Required parameter requestParameters.appSid was null or undefined when calling updateAppIosVoipCredentials.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/apps/{app_sid}/ios-voip-credentials`.replace(`{${"app_sid"}}`, encodeURIComponent(String(requestParameters.appSid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateAppIosVoipCredentialsRequestToJSON(requestParameters.streemApiUpdateAppIosVoipCredentialsRequest),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update IOS VOIP credentials for the given app
     * Update IOS VOIP Creds
     */
    async updateAppIosVoipCredentials(appSid, streemApiUpdateAppIosVoipCredentialsRequest) {
        await this.updateAppIosVoipCredentialsRaw({ appSid: appSid, streemApiUpdateAppIosVoipCredentialsRequest: streemApiUpdateAppIosVoipCredentialsRequest });
    }
}
//# sourceMappingURL=AppsApi.js.map